import React, {useEffect} from 'react';
import {Box, CircularProgress, makeStyles} from "@material-ui/core";
import {RewardsHeader} from "./Header";
import {RewardsTab} from "./Components/RewardsTab";
import {BP_MEDIUM} from "Theme/breakpoints";
import usePromotions, {usePromotionsProps} from "Hooks/api/usePromotions";
import {PROMO_PREFIXES} from "Constants";
import {RewardsInfo} from "Components/Rewards/Components/RewardsInfo";
import {IS_LOGGED_IN} from "Setup/config";
import {useSelector} from "react-redux";

export const useRewardsPageStyles = makeStyles(theme => {
    const RewardsPageSettings = theme.overrides.RewardsPage;
    return {
        root: {
            maxWidth: 1280,
        },
        rewardsPage: {
            borderRadius: RewardsPageSettings.borderRadius,
            background: RewardsPageSettings.background,
            backdropFilter: RewardsPageSettings.backdropFilter,
            color: RewardsPageSettings.headerTextColor,
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            boxShadow: RewardsPageSettings.boxShadow,
            margin: '1rem 0',
            [theme.breakpoints.up(BP_MEDIUM)]: {
                margin: '5rem 0',
                minHeight: 950,
                paddingBottom: '5rem',
            }

        },
    }
});

export default function Rewards() {
    const classes = useRewardsPageStyles();

    const {_list} = usePromotions();
    const {listPromotions} = _list();
    const {unclaimedPromotionsLoaded} = usePromotionsProps();

    useEffect(() => {
        if (!IS_LOGGED_IN && !unclaimedPromotionsLoaded) {
            listPromotions();
        }
    }, [unclaimedPromotionsLoaded]);

    const {rewardsLevel, rewardsPoints} = useSelector(state => {
        let rewardsLevel = 1;
        let rewardsPoints = 0;

        try {
            if (IS_LOGGED_IN) {
                const playerClaims = state.claims.playerClaims.claims;
                const rewardsLevelClaim = playerClaims.find(claim => claim.type === "RewardsLevel");
                if (rewardsLevelClaim) {
                    rewardsLevel = parseInt(rewardsLevelClaim.value);
                }

                const rewardsPointsClaim = playerClaims.find(claim => claim.type === "RewardsPoints");
                if (rewardsPointsClaim) {
                    rewardsPoints = parseInt(rewardsPointsClaim.value);
                }

                return {
                    rewardsLevel,
                    rewardsPoints
                };
            }
        } catch (e) {
            console.log(e);
        }

        return {
            rewardsLevel,
            rewardsPoints
        };
    });

    const {rewardsPromotions, rewardsPromotionsLoaded} = usePromotionsProps();
    const rewardsCards = rewardsPromotionsLoaded ? rewardsPromotions.filter(p => p.internalName.includes(PROMO_PREFIXES.REWARDS)) : [];
    const rewardsInfoCards = rewardsPromotionsLoaded ? rewardsPromotions.filter(p => p.internalName.includes(PROMO_PREFIXES.REWARDS_INFO)) : [];

    return (
        <section className={`${classes.root} row small-12 medium-11`}>
            <div className="column">
                <div className={classes.rewardsPage}>
                    {!rewardsPromotionsLoaded ?
                        <Box display="flex" justifyContent="center" my={5}>
                            <CircularProgress/>
                        </Box>
                        :
                        <>
                            <RewardsHeader currentLevel={rewardsLevel} currentPoints={rewardsPoints}/>
                            <RewardsTab currentLevel={rewardsLevel} promotions={rewardsCards}/>
                            <RewardsInfo infoPromos={rewardsInfoCards}/>
                        </>
                    }
                </div>
            </div>
        </section>
    );
}
